import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import '../CSS/Content.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import AddUserModal from './AddUser';
import { toast } from 'react-toastify';
import { useRef } from 'react';
import Select from 'react-select';
import { X } from "lucide-react"

const Content = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([

    ]);
    const [activeTab, setActiveTab] = useState('all');
    const url = process.env.REACT_APP_LINK
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null); // "approve" | "reject"
    const [selectedId, setSelectedId] = useState(null);
    const [youtubeLink, setYoutubeLink] = useState("");
    const [rejectReason, setRejectReason] = useState("");
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [showEnquiryModal, setShowEnquiryModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [showFilterDrawer, setShowFilterDrawer] = useState(false);
    const [showAssignSection, setShowAssignSection] = useState(false);
    const [showCheckAssignSection, setShowCheckAssignSection] = useState(false);
    const [selectedDateOptions, setSelectedDateOptions] = useState([]); // ['today', 'yesterday', 'custom']
    const [customDate, setCustomDate] = useState({ from: '', to: '' });
    const [filterStarred, setFilterStarred] = useState(false);
    const [notes, setNotes] = useState('');
    const [selectedServices, setSelectedServices] = useState([]);
    const [selectedEnquiryTypes, setSelectedEnquiryTypes] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [filterMode, setFilterMode] = useState('individual');
    const [selectAll, setSelectAll] = useState(false);
    const [selectedLeads, setSelectedLeads] = useState([]);
    const [loadingHbtreal, setLoadingHbtreal] = useState(true);
    const [searchEnquiry, setSearchEnquiry] = useState('');
    const [staffList, setStaffList] = useState([]);
    const [employeeViewFilter, setEmployeeViewFilter] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [showArchiveSection, setShowArchiveSection] = useState(false);
    const [staffName, setStaffName] = useState("")
    const token = localStorage.getItem("token");
    const [approveLoad, setApproveLoad] = useState(false)


    const handleEmployeeChange = (selectedOption) => {
        setSelectedEmployee(selectedOption ? selectedOption.value : ""); // Store selected employee'
        setStaffName(selectedOption ? selectedOption.staff_name : "")
    };

    const openModal1 = (id, type) => {
        setSelectedId(id);
        setModalType(type);
        setModalOpen(true);
    };

    const employeeOptions = staffList.map(staff => ({
        value: staff.user_id,
        staff_name: staff.full_name,
        label: `${staff.full_name} (ID: ${staff.user_id})`
    }));

    const handleSubmit = async () => {
        try {
            setApproveLoad(true);

            let payload = { id: selectedId, status: modalType === "approve" ? "Approved" : "Rejected" };
            if (modalType === "approve") payload.youtube_link = youtubeLink;
            if (modalType === "reject") payload.reason = rejectReason;

            const response = await fetch(`${url}/api/videos/change/${selectedId}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error("Request failed");

            setEmployees((prev) =>
                prev.map((item) => (item.id === selectedId ? { ...item, ...payload } : item))
            );
            fetchUsers();

            // Reset + close
            setYoutubeLink("");


            toast.success(
                modalType === "approve"
                    ? "Video approved and user notified 🎉"
                    : "Video rejected and user notified ❌"
            );

            setModalOpen(false);
            setYoutubeLink("");
            setRejectReason("");
        } catch (err) {
            console.error(err);
            toast.error("Something went wrong, please try again.");
        } finally {
            setApproveLoad(false); // ✅ always stop loader after request
        }
    };

    const [data, setData] = useState({
        email: "",
        password: "",
        full_name: "",
        mobile: ""
    })

    const [selected, setSelected] = useState(null);
    const [isOpen, setIsOpen] = useState(false);


    function openModal(video) {
        setSelected(video);
        setIsOpen(true);
        document.body.style.overflow = "hidden";
    }


    function closeModal() {
        setIsOpen(false);
        setSelected(null);
        document.body.style.overflow = "auto";
    }

    const toggleSection = (section) => {
        setShowAssignSection(section === 'assign' ? !showAssignSection : false);
        setShowCheckAssignSection(section === 'checkAssign' ? !showCheckAssignSection : false);
        setShowArchiveSection(section === 'archive' ? !showArchiveSection : false);
        // setShowUploadModal(section === 'upload' ? !showUploadModal : false);
    };

    const renderTags = (tags) => {
        try {
            const arr = typeof tags === "string" ? JSON.parse(tags) : tags || [];
            if (!Array.isArray(arr)) return [];
            return arr;
        } catch (e) {
            return [];
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };


    const handleCheckboxDateChange = (e) => {
        const { value, checked } = e.target;
        setSelectedDateOptions((prev) =>
            checked ? [...prev, value] : prev.filter((v) => v !== value)
        );
    };


    // const handleSelectAll = () => {
    //     setSelectedLeads(prevSelected => ({
    //         ...prevSelected,
    //         [currentPage]: selectAll ? [] : paginatedCurrentLeads.map(lead => lead.id),
    //     }));
    //     setSelectAll(!selectAll);
    //     // setNewlyAssignedLeads([]);
    //     // setAlreadyAssignedLeads([]);
    // };

    const handleSelectAll = () => {
        if (
            paginatedCurrentLeads.length > 0 &&
            paginatedCurrentLeads.every((lead) => selectedLeads.includes(lead.id))
        ) {
            // unselect all on current page
            setSelectedLeads((prev) =>
                prev.filter((id) => !paginatedCurrentLeads.some((lead) => lead.id === id))
            );
        } else {
            // select all on current page
            const allIds = paginatedCurrentLeads.map((lead) => lead.id);
            setSelectedLeads((prev) => [...new Set([...prev, ...allIds])]);
        }
    };


    const fetchUsers = async () => {
        try {
            const response = await fetch(`${url}/api/videos/admin1997`);
            const data = await response.json();
            setEmployees(data.reverse());

        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    // Filter employees according to activeTab
    const getTabData = () => {
        switch (activeTab) {
            case "all":
                return employees.filter((video) => !video.archieve);
            case "assigned":
                return employees.filter((video) => video.staff_id && !video.archieve);
            case "unassigned":
                return employees.filter((video) => !video.staff_id && !video.archieve);
            case "archive":
                return employees.filter((video) => video.archieve);
            default: // "all"
                return employees.filter((video) => !video.archieve);;
        }
    };

    // Fetch users from backend
    useEffect(() => {


        fetchUsers();
    }, []);

    const openEnquiryModal = () => {
        setShowEnquiryModal(true);
    };

    const handleClearFilters = () => {
        setSelectedDateOptions([]);
        setCustomDate({ from: '', to: '' });
        setFilterStarred(false);
        setNotes('');
        setSelectedServices([]);
        setSelectedEnquiryTypes([]);
        setSelectedDate('');
        setFiltersApplied(false);
        setFilterMode('individual');
    };

    const handleApplyFilters = () => {
        const datePriority = ['today', 'yesterday', 'custom'];
        const finalDate = datePriority.find((d) => selectedDateOptions.includes(d)) || '';
        setSelectedDate(finalDate);
        setFiltersApplied(true);
        setShowFilterDrawer(false);
        setFilterMode('combined');
    };
    // const closeEnquiryModal = () => {
    //     setShowEnquiryModal(false);
    //     fetchLeadsData();
    // };

    const toggleFilterDrawer = () => {
        setShowFilterDrawer(prevState => !prevState);
    };

    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const tabFilteredData = getTabData().filter((video) =>
        Object.values(video).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const totalPages = Math.ceil(tabFilteredData.length / itemsPerPage);
    const currentData = tabFilteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );


    const indexOfLastLead = currentPage * itemsPerPage;
    const indexOfFirstLead = indexOfLastLead - itemsPerPage;

    const paginatedCurrentLeads = tabFilteredData
        .filter((lead) => !employeeViewFilter || lead.staff_id === employeeViewFilter)
        .slice(indexOfFirstLead, indexOfLastLead);



    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const handleDelete = (email) => {
        const updatedEmployees = employees.filter(employee => employee.email !== email);
        setEmployees(updatedEmployees);
    };

    const handleStatusChange = (id, status) => {
        setEmployees((prev) =>
            prev.map((item) =>
                item.id === id ? { ...item, status } : item
            )
        );

    };

    const handleAssign = async () => {
        if (!selectedEmployee) {
            toast.error("Please select an employee before assigning.", {
                position: "top-center",
                autoClose: 2000,
            });
            return;
        }

        const selectedIds = selectedLeads || [];

        if (selectedIds.length === 0) {
            toast.error("No leads selected for assignment.", {
                position: "top-center",
                autoClose: 2000,
            });
            return;
        }

        try {
            const response = await fetch(`${url}/api/videos/assign`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    employee_id: selectedEmployee,        // staff_id
                    staff_name: staffName,
                    lead_ids: selectedIds
                }),
            });

            if (response.ok) {
                toast.success("assigned successfully!", {
                    position: "top-center",
                    autoClose: 2000,
                });
                fetchUsers();
                setSelectedLeads([]);
                setSelectAll(false);
            } else {
                const err = await response.json();
                toast.error(err.error || "Failed to assign.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error assigning.");
        }
    };


    const handleUnassign = async () => {
        const selectedIds = selectedLeads || [];
        if (selectedIds.length === 0) {
            toast.error("Nothing selected to unassign.", {
                position: "top-center",
                autoClose: 2000,
            });
            return;
        }

        try {
            const response = await fetch(`${url}/api/videos/unassign`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ lead_ids: selectedIds }),
            });

            if (response.ok) {
                toast.success("Unassigned successfully!", {
                    position: "top-center",
                    autoClose: 2000,
                });
                fetchUsers();
                setSelectedLeads([]);
                setSelectAll(false);
            } else {
                const err = await response.json();
                toast.error(err.error || "Failed to unassign.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error unassigning.");
        }
    };


    const handleArchive = async () => {
        const selectedIds = selectedLeads || [];
        if (selectedIds.length === 0) {
            toast.error("Nothing selected to archive.", {
                position: "top-center",
                autoClose: 2000,
            });
            return;
        }

        try {
            const response = await fetch(`${url}/api/videos/archive`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ lead_ids: selectedIds }),
            });

            if (response.ok) {
                toast.success("Archived successfully!", {
                    position: "top-center",
                    autoClose: 2000,
                });
                fetchUsers();
                setSelectedLeads([]);
                setSelectAll(false);
            } else {
                const err = await response.json();
                toast.error(err.error || "Failed to archive.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error archiving.");
        }
    };

    const handleUnarchive = async () => {
        const selectedIds = selectedLeads || [];
        if (selectedIds.length === 0) {
            toast.error("Nothing selected to unarchive.", {
                position: "top-center",
                autoClose: 2000,
            });
            return;
        }

        try {
            const response = await fetch(`${url}/api/videos/unarchive`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ lead_ids: selectedIds }),
            });

            if (response.ok) {
                toast.success("Unarchived successfully!", {
                    position: "top-center",
                    autoClose: 2000,
                });
                fetchUsers();
                setSelectedLeads([]);
                setSelectAll(false);
            } else {
                const err = await response.json();
                toast.error(err.error || "Failed to unarchive.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error unarchiving.");
        }
    };



    const SearchStaff = async () => {
        try {
            const response = await fetch(`${url}/api/staff/admin1997`); // Fetch staff data
            const res = await response.json();
            setStaffList(res); // ✅ Save staff data in state
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });
        }
    };

    useEffect(() => {
        SearchStaff();
    }, [])

    const totalAllCount = employees.filter((video) => !video.archieve).length;
    const totalAssignedCount = employees.filter((video) => video.staff_id && !video.archieve).length;
    const totalUnassignedCount = employees.filter((video) => !video.staff_id && !video.archieve).length;
    const totalArchiveCount = employees.filter((video) => video.archieve).length;



    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Content</h1>
                </div>
                {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div> */}
                <div className="lsuv-oms__header">
                    <div className="lsuv-tabs-oms">

                        <div className={`lsuv-tab-oms ${activeTab === "all" ? "lsuv-tab-oms-active" : ""}`}
                            onClick={() => { setActiveTab("all"); setCurrentPage(1); }}>
                            All <span>({totalAllCount})</span>
                        </div>

                        <div className={`lsuv-tab-oms ${activeTab === "assigned" ? "lsuv-tab-oms-active" : ""}`}
                            onClick={() => { setActiveTab("assigned"); setCurrentPage(1); }}>
                            Assigned <span>({totalAssignedCount})</span>
                        </div>

                        <div className={`lsuv-tab-oms ${activeTab === "unassigned" ? "lsuv-tab-oms-active" : ""}`}
                            onClick={() => { setActiveTab("unassigned"); setCurrentPage(1); }}>
                            Unassigned <span>({totalUnassignedCount})</span>
                        </div>

                        <div className={`lsuv-tab-oms ${activeTab === "archive" ? "lsuv-tab-oms-active" : ""}`}
                            onClick={() => { setActiveTab("archive"); setCurrentPage(1); }}>
                            Archive <span>({totalArchiveCount})</span>
                        </div>
                        <div className="search-container45">
                            <input
                                type="text"
                                className="search-input45"
                                placeholder="Search by ID, Name, Title, or Category..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            {searchQuery && (
                                <button className="clear-btn45" onClick={() => setSearchQuery('')}>

                                </button>
                            )}
                        </div>


                    </div>
                    <div className="lsuv-header-icons-oms">
                        {/* <div className="lsuv-search-oms" onClick={() => setShowSearchBar(!showSearchBar)}>
                            <i className="fa-solid fa-magnifying-glass"></i>
                        </div> */}
                        {/* <div className="lsuv-filter-oms" onClick={toggleFilterDrawer}>
                            <i className="fa-solid fa-filter"></i>
                        </div> */}
                        <div className="lsuv-three-dots" onClick={() => setShowDropdown(!showDropdown)} ref={dropdownRef}>
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                            {showDropdown && (
                                <div className="lsuv-dropdown-menu">
                                    <div className="lsuv-dropdown-item" onClick={() => toggleSection("assign")}>
                                        Assign
                                    </div>
                                    {/* <div className="lsuv-dropdown-item" onClick={() => toggleSection("checkAssign")}>
                                        Check assign
                                    </div> */}
                                    <div className="lsuv-dropdown-item" onClick={() => toggleSection("archive")}>
                                        Archive
                                    </div>
                                    {/* <div className="lsuv-dropdown-item" onClick={() => toggleSection("upload")}>
                                        Upload excel
                                    </div>
                                    <div className="lsuv-dropdown-item" onClick={openEnquiryModal}>
                                        Add Enquiry
                                    </div> */}
                                    {/* <a style={{ textDecoration: "none" }} href="mailto:support@100billiontech.com" aria-label="Email Customer Support">
                                        <div className="lsuv-dropdown-item">Support</div>
                                    </a> */}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {showAssignSection && (
                    <div className="lsuv-assign-section">
                        <div className="lsuv-assign-close-oms" onClick={() => setShowAssignSection(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                        <div className="lsuv-assign-row">
                            <div className="lsuv-assign-checkbox">
                                <input
                                    type="checkbox"
                                    checked={
                                        paginatedCurrentLeads.length > 0 &&
                                        paginatedCurrentLeads.every((lead) => selectedLeads.includes(lead.id))
                                    }

                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setSelectedLeads(paginatedCurrentLeads.map((lead) => lead.id));
                                        } else {
                                            setSelectedLeads([]);
                                        }
                                    }}
                                />
                                <label htmlFor="selectAll">All</label>

                            </div>
                            <div className="lsuv-assign-select">
                                <Select
                                    options={employeeOptions}
                                    isSearchable={true} // ✅ Enable search
                                    placeholder="Search"
                                    onChange={handleEmployeeChange}
                                    value={employeeOptions.find(emp => emp.value === selectedEmployee)} // Preserve selection
                                />
                            </div>
                        </div>
                        <div className="lsuv-assign-row-buttons">
                            <button className="lsuv-btn-assign" onClick={handleAssign}>Assign</button>
                            <button className="lsuv-btn-unassign" onClick={handleUnassign}>Unassign</button>
                        </div>
                    </div>
                )}

                {showCheckAssignSection && (
                    <div className="lsuv-assign-section">
                        <div className="lsuv-assign-close-oms" onClick={() => setShowCheckAssignSection(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>

                        <div className="lsuv-assign-row">
                            <div className="lsuv-assign-checkbox">
                                <input
                                    type="checkbox"
                                    id="selectAll"
                                    checked={
                                        paginatedCurrentLeads.length > 0 &&
                                        paginatedCurrentLeads.every((lead) => selectedLeads.includes(lead.id))
                                    }
                                    onChange={handleSelectAll}
                                />

                                <label htmlFor="selectAll">All</label>
                            </div>
                            <div className="lsuv-assign-select">
                                <Select
                                    options={staffList.map((staff) => ({
                                        value: staff.emplyee_ID,
                                        label: `${staff.firstName} ${staff.lastName} (ID: ${staff.emplyee_ID})`,
                                    }))}
                                    placeholder="Filter by Assigned Employee"
                                    isClearable
                                    onChange={(selectedOption) =>
                                        setEmployeeViewFilter(selectedOption ? selectedOption.value : null)
                                    }
                                    value={
                                        employeeViewFilter
                                            ? {
                                                value: employeeViewFilter,
                                                label: staffList.find((s) => s.emplyee_ID === employeeViewFilter)?.firstName +
                                                    " " +
                                                    staffList.find((s) => s.emplyee_ID === employeeViewFilter)?.lastName
                                            }
                                            : null
                                    }
                                />
                            </div>
                        </div>
                        <div className="lsuv-assign-row-buttons">
                            <button className="lsuv-btn-unassign" onClick={handleUnassign}>Unassign</button>
                        </div>
                    </div>
                )}

                {showArchiveSection && (
                    <div className="lsuv-assign-section">
                        <div className="lsuv-assign-close-oms" onClick={() => setShowArchiveSection(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                        <div className="lsuv-assign-row archive-div-oms">
                            <div className="lsuv-assign-checkbox">
                                <input
                                    type="checkbox"
                                    id="selectAll"
                                    checked={
                                        paginatedCurrentLeads.length > 0 &&
                                        paginatedCurrentLeads.every((lead) => selectedLeads.includes(lead.id))
                                    }
                                    onChange={handleSelectAll}
                                />

                                <label htmlFor="selectAll">All</label>
                            </div>
                            <div className="lsuv-assign-row-buttons">
                                <button className="lsuv-btn-assign" onClick={handleArchive}>Archive</button>
                                <button className="lsuv-btn-unassign" onClick={handleUnarchive}>Unarchive</button>
                            </div>
                        </div>
                    </div>
                )}

                {showSearchBar && (
                    <div className="lsuv-searchbar-container">
                        <input
                            type="text"
                            className="lsuv-searchbar-input"
                            placeholder="Search ..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                )}

                {showFilterDrawer && (
                    <div className={`lsuv-filter-drawer ${!showFilterDrawer ? 'closed' : ''}`}>
                        <div className="lsuv-filter-drawer-header">
                            <div className="lsuv-span-and-back-oms">
                                <i class="fa-solid fa-chevron-left" onClick={toggleFilterDrawer}></i>
                                <span>Filter Options</span>
                            </div>
                            <button onClick={handleClearFilters}>Clear</button>
                        </div>
                        <div className="lsuv-filter-drawer-content">
                            <div className="lsuv-filter-group-oms">
                                <p className="lsuv-filter-label">Filter by Date</p>
                                <div className="lsuv-filter-radio-group-oms">
                                    {['today', 'yesterday', 'custom'].map((value) => (
                                        <div className="lsuv-filter-radio-btn" key={value}>
                                            <input
                                                type="checkbox"
                                                id={value}
                                                name="datefilter"
                                                value={value}
                                                checked={selectedDateOptions.includes(value)}
                                                onChange={handleCheckboxDateChange}
                                            />
                                            <label htmlFor={value}>
                                                {value === 'today' && 'Today'}
                                                {value === 'yesterday' && 'Yesterday'}
                                                {value === 'custom' && 'Custom Date'}
                                            </label>
                                        </div>
                                    ))}
                                </div>

                                {selectedDateOptions.includes('custom') && (
                                    <div className="lsuv-custom-date-range">
                                        <div className="lsuv-custom-date-input-oms">
                                            <label htmlFor="fromDate">From</label>
                                            <input
                                                type="date"
                                                id="fromDate"
                                                name="fromDate"
                                                value={customDate.from}
                                                onChange={(e) => setCustomDate({ ...customDate, from: e.target.value })}
                                            />
                                        </div>

                                        <div className="lsuv-custom-date-input-oms">
                                            <label htmlFor="toDate">To</label>
                                            <input
                                                type="date"
                                                id="toDate"
                                                name="toDate"
                                                value={customDate.to}
                                                onChange={(e) => setCustomDate({ ...customDate, to: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>


                        </div>
                        <div className="lsuv-filter-drawer-footer-oms">
                            <button
                                className="lsuv-filter-drawer-close-btn"
                                onClick={handleApplyFilters}
                            >
                                Apply Filter
                            </button>
                        </div>
                    </div>
                )}

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>#</th>
                                <th>Date</th>
                                <th>Name</th>

                                <th>Title</th>
                                <th>User ID</th>
                                <th>Category</th>
                                <th>Pay Status</th>
                                <th>Approved</th>
                                <th>Rejected</th>
                                 <th>Youtube video link</th>
                                <th>Mobile</th>

                                <th>Assigned</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((video, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}.</td>

                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedLeads.includes(video.id)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedLeads((prev) => [...prev, video.id]);
                                                    } else {
                                                        setSelectedLeads((prev) => prev.filter((id) => id !== video.id));
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td>{new Date(video.createdAt).toLocaleString()}</td>

                                 <td>{video.User?.full_name || "Unassigned"}</td>


                                        <td onClick={() => {
                                            openModal(video)
                                        }}
                                            style={{ cursor: "pointer" }}
                                            className="truncate">{video.title}</td>
                                        <td>{video.user_id}</td>
                                        <td>{video.category}</td>
                                        {/* <td>{video.pay_status}</td> */}  <td>
                                            {video.pay_status === "pending" || video.pay_status === "Pending"
                                                ? "Failed"
                                                : video.pay_status}
                                        </td>


                                        {/* ✅ Approve column */}
                                        <td>
                                            <button
                                                className={`releases-approve ${video.status === "Approved" ? "active" : ""}`}
                                                onClick={() => openModal1(video.id, "approve")}
                                            >
                                                Approve
                                            </button>
                                        </td>

                                        {/* ❌ Reject column */}
                                        <td>
                                            <button
                                                className={`releases-reject ${video.status === "Rejected" ? "active" : ""}`}
                                                onClick={() => openModal1(video.id, "reject")}
                                            >
                                                Reject
                                            </button>
                                        </td>
<td
  style={{
    textAlign: "center",
    verticalAlign: "middle",
    height: "60px", // optional, better visual balance
  }}
>
  {video.youtube_video_link ? (
    <button
      onClick={() => {
        window.open(`${video.youtube_video_link}?autoplay=1`, "_blank");
      }}
      style={{
        backgroundColor: "#2563eb",
        color: "white",
        border: "none",
        borderRadius: "8px",
        padding: "6px 12px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto", // centers button horizontally
      }}
    >
      ▶
    </button>
  ) : (
    <span style={{ display: "block", textAlign: "center" }}>N/A</span>
  )}
</td>



                                        <td>
                                          
                                                    <p>{video.User?.mobile || "N/A"}</p>
                                                  
                                            
                                        </td>

                                        <td>
                                            {
                                                video.staff_id ?
                                                    <p>{video.staff_name} - {video.staff_id}</p> :
                                                    "N/A"
                                            }
                                        </td>

                                        <td>
                                            <button
                                                onClick={async () => {
                                                    const res = await fetch(`${url}/api/videos/downloadvideo/${video.vimeo_uri.split('/').pop()}`);
                                                    const data = await res.json();
                                                    if (data.url) {
                                                        window.open(data.url, "_blank"); // open or force download
                                                    }
                                                }}
                                                className="download-button">Download</button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center" }}>
                                        No videos found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>


                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i className="fa-solid fa-chevron-left"></i><i className="fa-solid fa-chevron-left"></i>
                    </button>

                    <button className="active">{currentPage}</button>

                    {currentPage + 1 < totalPages && (
                        <>
                            <button onClick={() => paginate(currentPage + 1)}>
                                {currentPage + 1}
                            </button>
                            {currentPage + 2 < totalPages && <span className="dots">...</span>}
                            <button onClick={() => paginate(totalPages)}>
                                {totalPages}
                            </button>
                        </>
                    )}

                    {currentPage === totalPages - 1 && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i className="fa-solid fa-chevron-right"></i><i className="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div>

            {isOpen && selected && (
                <div className="releases-modal-overlay" onClick={closeModal}>
                    <div className="releases-modal" onClick={(e) => e.stopPropagation()}>
                        <header className="releases-modal-header">
                            <h2 className="releases-modal-title">{selected.title}</h2>
                            <button className="releases-modal-close" onClick={closeModal} aria-label="Close">
                                <X />
                            </button>
                        </header>

                        <div className="releases-modal-body">
                            <div className="releases-left">
                                <div className="releases-thumb">
                                    {selected.thumbnail_path ? (
                                        <img src={`${url}${selected.thumbnail_path}`} alt={selected.title} />
                                    ) : (
                                        <div className="releases-thumb-placeholder">No Thumbnail</div>
                                    )}
                                </div>

                                <div className="releases-meta">
                                    <div><strong>Category:</strong> {selected.category}</div>
                                    <div><strong>Audience:</strong> {selected.audience}</div>
                                    <div><strong>Pay Status:</strong> {selected.pay_status || 'N/A'}</div>
                                    <div><strong>Date:</strong> {new Date(selected.createdAt).toLocaleString()}</div>
                                    {
                                        selected?.staff_id &&
                                        <div><strong>Assigned to:</strong> {selected.staff_name} - {selected.staff_id}</div>
                                    }

                                    <div className="releases-tags"><strong>Tags:</strong> {renderTags(selected.tags).join(', ') || '-'}</div>
                                </div>

                                <div className="releases-actions">
                                    <a href={selected.vimeo_link} target="_blank" rel="noreferrer" className="releases-action-btn">Open Vimeo</a>
                                    <button className="releases-action-btn secondary" onClick={async () => {
                                        const res = await fetch(`${url}/api/videos/downloadvideo/${selected.vimeo_uri.split('/').pop()}`);
                                        const data = await res.json();
                                        if (data.url) {
                                            window.open(data.url, "_blank"); // open or force download
                                        }
                                    }}
                                    >Download</button>
                                </div>
                            </div>

                            <div className="releases-right">
                                <h3 className="releases-section-title">Description</h3>
                                <div className="releases-description">{selected.description || 'No description provided.'}</div>

                                <h3 className="releases-section-title">Extra Details</h3>
                                <div className="releases-grid">
                                    <div className="releases-grid-item"><strong>Youtube Link</strong><span>{selected.youtube_video_link || '-'}</span></div>
                                    <div className="releases-grid-item"><strong>Rejected Reason</strong><span>{selected.rejected_reason || '-'}</span></div>
                                    <div className="releases-grid-item"><strong>Video Status</strong><span>{selected.status || '-'}</span></div>
                                    <div className="releases-grid-item"><strong>Pay ID</strong><span>{selected.pay_id || '-'}</span></div>
                                </div>
                            </div>
                        </div>

                        <footer className="releases-modal-footer">
                            <button className="releases-close-btn" onClick={closeModal}>Close</button>
                        </footer>
                    </div>
                </div>
            )}


            {modalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded shadow-lg w-96">
                        <h2 className="text-lg font-bold mb-4">
                            {modalType === "approve" ? "Approve Video" : "Reject Video"}
                        </h2>

                        {modalType === "approve" && (
                            <input
                                type="text"
                                placeholder="Enter YouTube link"
                                value={youtubeLink}
                                onChange={(e) => setYoutubeLink(e.target.value)}
                                className="w-full border p-2 rounded mb-4"
                            />
                        )}

                        {modalType === "reject" && (
                            <textarea
                                placeholder="Enter rejection reason"
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                                className="w-full border p-2 rounded mb-4"
                            />
                        )}

                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => setModalOpen(false)}
                                className="px-4 py-2 bg-gray-300 rounded"
                            >
                                Cancel
                            </button>


                            <button
                                onClick={async () => {
                                    try {
                                        setApproveLoad(true);

                                        let payload = { id: selectedId, status: modalType === "approve" ? "Approved" : "Rejected" };
                                        if (modalType === "approve") payload.youtube_link = youtubeLink;
                                        if (modalType === "reject") payload.reason = rejectReason;

                                        const response = await fetch(`${url}/api/videos/change/${selectedId}`, {
                                            method: "POST",
                                            headers: { "Content-Type": "application/json" },
                                            body: JSON.stringify(payload),
                                        });

                                        if (!response.ok) throw new Error("Request failed");

                                        setEmployees((prev) =>
                                            prev.map((item) =>
                                                item.id === selectedId ? { ...item, ...payload } : item
                                            )
                                        );

                                        toast.success(
                                            modalType === "approve"
                                                ? "Video approved and user notified 🎉"
                                                : "Video rejected and user notified ❌"
                                        );

                                        setModalOpen(false);
                                        setYoutubeLink("");
                                        setRejectReason("");
                                    } catch (err) {
                                        console.error(err);
                                        toast.error("Something went wrong, please try again.");
                                    } finally {
                                        setApproveLoad(false); // ✅ always stop loader after request
                                    }
                                }}
                                disabled={approveLoad}
                                className={`px-4 py-2 rounded text-white ${approveLoad ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
                                    }`}
                            >
                                {approveLoad ? (
                                    <span className="flex items-center">
                                        <svg
                                            className="animate-spin h-4 w-4 mr-2 text-white"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"
                                            ></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                            ></path>
                                        </svg>
                                        Processing...
                                    </span>
                                ) : (
                                    "Submit"
                                )}
                            </button>


                        </div>
                    </div>
                </div>
            )}
            {modalOpen && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h2>{modalType === "approve" ? "Approve Video" : "Reject Video"}</h2>

                        {modalType === "approve" && (
                            <input
                                type="text"
                                placeholder="Enter YouTube link"
                                value={youtubeLink}
                                onChange={(e) => setYoutubeLink(e.target.value)}
                            />
                        )}

                        {modalType === "reject" && (
                            <textarea
                                placeholder="Enter rejection reason"
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                            />
                        )}

                        <div className="modal-actions">
                            <button onClick={() => setModalOpen(false)} className="cancel-btn">
                                Cancel
                            </button>
                            <button onClick={handleSubmit} className="submit-btn">
                                {
                                    approveLoad ? "Processing..." : "Submit"
                                }
                            </button>
                        </div>
                    </div>
                </div>
            )}


            <AddUserModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}
                couponform={data}
                setCouponForm={setData}
                handleSubmit={handleSubmit}
                statusOptions={statusOptions}
                handleChange={handleChange}
            />





        </>
    );
};

export default Content;
